import React from 'react';
import {
  DS_BookAppointmentButton,
  DS_FlagshipLabel,
  DS_LocationContact,
  DS_StarRating,
} from '../../../sections/DS_LocationHero/elements';

import { StyledBookButtonWrapper, StyledLocationHeader, StyledLocationWrapper } from './styles';

const InfoWindow = ({ location, metaData }) => {
  const { code, heading, address, flagshipStoreLabel, distanceInKm } = location;
  const { flagshipLocationLabel, useFlagshipStoreLabel, bookingButton, isBookingFunnel, onLocationSelection } =
    metaData;

  return (
    <StyledLocationWrapper>
      <StyledLocationHeader>
        {distanceInKm ? <div>{distanceInKm} km</div> : <DS_StarRating />}
        <DS_FlagshipLabel
          label={flagshipStoreLabel || flagshipLocationLabel}
          shouldUseLabel={useFlagshipStoreLabel}
          isLocationFlagship={flagshipStoreLabel}
        />
      </StyledLocationHeader>
      <DS_LocationContact heading={heading} address={address} ellipsis={true} />
      <StyledBookButtonWrapper>
        <DS_BookAppointmentButton
          label={bookingButton?.title}
          locationCode={code}
          fixWidth={true}
          url={bookingButton?.url}
          isBookingFunnel={isBookingFunnel}
          onLocationSelection={() => onLocationSelection(location)}
        />
      </StyledBookButtonWrapper>
    </StyledLocationWrapper>
  );
};

export default InfoWindow;
